import React from 'react';
import { IBwjGraphicComponentProps } from '../framework/entities/bwj-graphic-component';

export const SuccessGraphic: React.FunctionComponent<IBwjGraphicComponentProps> = (props) => {

  return (
    <i style={props.style}>
      <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="328.81500244140625 65.84700012207031 218.96002197265625 221.76499938964844"
        xmlSpace="preserve"
        style={{ width: '100%', height: '100%' }}
      >
        <g id="x">
          <g>
            <g>
              <g>
                <linearGradient id="SVGID_1_" gradientUnits="userSpaceOnUse" x1="512.2271" y1="107.777" x2="394.0431" y2="253.8218">
                  <stop offset="0" style={{ stopColor: '#3BB005' }}/>
                  <stop offset="1" style={{stopColor: '#008545' }}/>
                </linearGradient>
                <polygon style={{fill: 'url(#SVGID_1_)'}} points="547.775,94.722 430.21,252.645 396.715,219.272 510.944,65.847     "/>
                
                  <linearGradient id="SVGID_00000035521926661035779660000003627286780601851777_" gradientUnits="userSpaceOnUse" x1="403.6517" y1="257.6551" x2="339.8536" y2="196.9583">
                  <stop offset="0" style={{stopColor:'#3BB005'}}/>
                  <stop offset="1" style={{stopColor: '#008545'}}/>
                </linearGradient>
                <polygon style={{fill:'url(#SVGID_00000035521926661035779660000003627286780601851777_)'}} points="431.865,250.422       404.175,287.612 328.815,220.532 358.895,185.762 396.715,219.272     "/>
              </g>
            </g>
          </g>
        </g>
      </svg>
    </i>
  );
};
